import { render } from "./speechBubblePointer.vue?vue&type=template&id=142b3e38&scoped=true"
import script from "./speechBubblePointer.vue?vue&type=script&lang=ts"
export * from "./speechBubblePointer.vue?vue&type=script&lang=ts"

import "./speechBubblePointer.vue?vue&type=style&index=0&id=142b3e38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-142b3e38"

export default script